//User actions

export const SET_USER_FROM_TOKEN = 'SET_USER_FROM_TOKEN';

export const LOGOUT_USER = 'LOGOUT_USER';



// WEBPACK FOOTER //
// ./src/static/_types.js